import React, { useState } from 'react';
import { Circle, Wrapper } from './Toggler.styles';

interface TogglerProps<T> {
  name: T;
  handleToggleState: (name: T) => void;
  active?: boolean;
}

const Toggler = <T,>({ name, handleToggleState, active }: TogglerProps<T>) => {
  const isControlled = active !== undefined;
  const [internalActive, setInternalActive] = useState(false);
  const isActive = isControlled ? active : internalActive;

  const handleToggle = () => {
    if (!isControlled) {
      setInternalActive(state => !state);
    }
    handleToggleState(name);
  };

  return (
    <Wrapper onClick={handleToggle} active={isActive}>
      <Circle active={isActive} />
    </Wrapper>
  );
};

export default Toggler;
